export interface Example {
    marker: string;
    activationPhrase: string;
    request: string;
}

export const compareExamples = (e1: Example, e2: Example) => {
    return e1.marker === e2.marker && e1.activationPhrase === e2.activationPhrase && e1.request === e2.request;
};

export const makeEmptyExample = (): Example => ({
    marker: '',
    activationPhrase: '',
    request: '',
});

export const isEmptyExample = (example: Example) => {
    return !example || (!example.marker && !example.activationPhrase && !example.request);
};

export const markers = [
    { text: 'запусти навык', hasRequest: false },
    { text: 'запусти чат с', hasRequest: false },
    { text: 'давай поиграем в', hasRequest: false },
    { text: 'сыграем в', hasRequest: false },
    { text: 'давай сыграем в', hasRequest: false },
    { text: 'поиграем в', hasRequest: false },
    { text: 'скажи', hasRequest: true },
    { text: 'попроси', hasRequest: true },
    { text: 'узнай у', hasRequest: true },
    { text: 'спроси у', hasRequest: true },
];

export const reservedWords = ['алиса', 'яндекс'];

export enum VerificationOptions {
    Website = 'website',
    Organization = 'organization',
}

export const verificationLabels: Record<VerificationOptions, string> = {
    [VerificationOptions.Website]: 'Через сайт',
    [VerificationOptions.Organization]: 'Через справочник',
};

export interface SmartHomeDeepLinks {
    ios?: {
        url?: string | null;
        fallbackUrl?: string | null;
    };
    android?: {
        url?: string | null;
    };
}
